<div *ngIf="newPayment; else notNewPayment">
    <div *ngIf="this.cart">
        <!-- <pme-mobile-dropdown> -->

        <div content>
            <mat-card class="pme-new-cart-card" *ngIf="this.cart">
                <mat-card-content>
                    <p class="color-blue">Resumo do pedido:</p>
                    <mat-divider inset></mat-divider>
                    <div class="product-choice">
                        <b class="font-size-16">{{cart.product.classificationIdentifier ===
                            "consulta-e-recuperacao-de-dividas" ? "Pacote de créditos" : getPlanType()}}</b>
                        <p id="description">{{cart.product.classificationName}}</p>

                    </div>
                    <div class="product-choice-price">
                       <!-- <b>{{cart.product.value | currency: 'R$'}}</b>-->
                       <b>
                        {{  this.currentPaymentMethod === "CREDIT_CARD" && this.installmentSelected && this.installmentSelected.installments > 0
                            ? (this.installmentSelected.installments + 'X de ' + (this.installmentSelected.installmentValue | currency:'BRL'))
                            : (this.cart.totalValue | currency:'BRL')
                        }}
                      </b>

                    </div>

                    <div class="discount-description">

                        <!-- Descontos Try buy -->
                        <div *ngIf="this.trialCoupon">
                            <p>
                                <span class="font-size-16 color-blue-coupon">Desconto aplicado</span><br>
                                <b class="color-blue-coupon"> {{this.trialCoupon.deal}} gratuitos</b>
                                podendo cancelar a qualquer momento durante seu período de teste sem riscos.
                            </p>
                        </div>

                        <!-- Desconto de balanço extra -->

                        <!--  -->
                    </div>
                    <div class="change-plan" [ngClass]="{disabled: paymentFormSubmitting}" *ngIf="cart.product.classificationIdentifier!='recupera'">

                        <p (click)="paymentFormSubmitting ? null : changePlan()">
                            {{ cart.product.classificationName === 'Consulta e Cobrança de Dívidas' ? 'Alterar pacote' : (cart.product.classificationName === 'Assinatura' ? 'Alterar plano' : returnToShopWindowText) }}
                          </p>
                    </div>

                    <div *ngIf="this.filteredCoupons && this.filteredCoupons.length > 0 ">
                        <div class="economyMessage">
                            <img id="gift" src="/assets/images/dialog-icons/gift.png">
                            <div>
                                <p>Você economizou {{ getTotalDiscount() | currency: 'R$' }}</p>
                            </div>
                        </div>
                    </div>
                    <mat-divider inset></mat-divider>
                    <div class="pme-new-coupon" *ngIf="this.checkShowFormularyCoupon(this.cart)">
                        <form class="display-utils-row-nowrap display-utils-start-center display-utils-gap-8" [formGroup]="this.couponFb">
                            <mat-form-field class="display-utils-flex-75" appearance="outline" [ngClass]="{
                                        'pme-coupon-invalid': this.couponIsInvalid && this.cart.couponIdentifier && this.isAplicarButton,
                                        'pme-coupon-applied': this.cart.hasValidAppliedCoupon
                                    }">
                                <!-- <div *ngIf="this.theresValue || this.isFocused"> -->
                                    <mat-label class="labelInput">Código do cupom</mat-label>
                                <!-- </div> -->
                                <input class="inputCoupon" matInput #couponIdentifier
                                    [(ngModel)]="this.cart.couponIdentifier"
                                    (input)="formatCoupon(); thereIsInputValue()" formControlName="couponIdentifier"
                                    placeholder="Código do cupom" (focus)="this.isFocused = true"
                                    (blur)="this.isFocused = false">
                                <mat-icon *ngIf="this.cart.hasValidAppliedCoupon" matSuffix>check_circle</mat-icon>
                            </mat-form-field>

                        <button mat-stroked-button color="primary" class="pme-coupon-button display-utils-flex-25"
                            [disabled]="!this.cart.couponIdentifier || paymentFormSubmitting"
                            *ngIf="!this.submittingCouponCode"
                            (click)="this.isAplicarButton ? removeCoupon() : applyCoupon(false)" matSuffix>
                            {{this.isAplicarButton ? "Remover" : "Aplicar" }}
                        </button>
                        <button class="pme-coupon-spinner" mat-button disabled *ngIf="this.submittingCouponCode"
                            matSuffix>
                            <mat-spinner diameter="26" aria-label="Carregando"></mat-spinner>
                        </button>
                        </form>
                    </div>

                    <div
                        *ngIf="!this.cart.hasValidAppliedCoupon && !this.isUpgrade && this.cart && this.cart.couponIdentifier && this.isAplicarButton && this.getCartErrors().couponIdentifier; else mensagemAlternativa">
                        <mat-error class="errorMessage">{{this.getCartErrors().couponIdentifier}}</mat-error>
                    </div>

                    <ng-template #mensagemAlternativa>
                        <div
                            *ngIf="!this.cart.hasValidAppliedCoupon && this.cartService && this.cartService.carts && !this.isUpgrade && this.cart && this.cart.couponIdentifier && this.isAplicarButton &&  this.couponIsInvalid ">
                            <mat-error class="errorMessage">{{this.getCouponError()}}</mat-error>
                        </div>
                    </ng-template>


                    <!-- Créditos adquiridos -->
                    <!-- <div>
                            <div class="acquired-bonus"
                                *ngIf="this.extraBalanceCoupon && this.extraBalanceCoupon.length > 0">
                                <p class="font-size-16 color-blue-coupon">Créditos adquiridos</p>
                                <b class="color-blue-coupon">{{this.extraBalanceSum + cart.product.value | currency:
                                    'R$'}}</b>
                            </div>
                        </div> -->
                    <div>
                        <div class="discount-description-price subtotal">
                            <p class="font-size-16 color-blue-coupon">Subtotal</p>
                            <div>
                                <li class="display-utils-row display-utils-between-center display-utils-gap-8">
                                    <b class="color-blue-coupon">
                                        {{ (cart.baseValue | currency:'BRL')  }}
                                        </b>
                                </li>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="discount-description-price"
                            *ngIf="this.filteredCoupons && this.filteredCoupons.length > 0 ">
                            <p class="font-size-16 color-blue-coupon">Desconto</p>
                            <div>
                                <li class="display-utils-row display-utils-between-center display-utils-gap-8">
                                    <b class="color-purple-discount">{{getTotalDiscount() |
                                        currency:
                                        '-R$'}}</b>
                                </li>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="discount-description-price"
                            *ngIf="this.extraBalanceCoupon && this.extraBalanceCoupon.length > 0">
                            <p class="font-size-16 color-blue-coupon">Bônus</p>
                            <div>
                                <li class="display-utils-row display-utils-between-center display-utils-gap-8"
                                    *ngFor="let discount of this.extraBalanceCoupon">
                                    <b class="color-green-bonus">{{discount.totalCredit - cart.product.value |
                                        currency:
                                        '+R$'}}</b>
                                </li>
                            </div>
                        </div>
                    </div>
                    <mat-divider inset></mat-divider>

                    <div class="pme-cart-total">
                        <div class="pme-cart-total-content display-utils-row-wrap display-utils-between-center display-utils-gap-8">
                            <div *ngIf="!trialCoupon" class="mat-h3">
                                <p class="color-blue-coupon">Total a pagar</p>
                            </div>
                            <div *ngIf="trialCoupon">
                                <p>
                                    <span>Total a pagar após</span><br>
                                    <b class="color-blue-coupon">{{this.trialCoupon.deal}} de teste</b>
                                </p>
                            </div>
                            <div class="pme-text-right pme-cart-nowrap" *ngIf="validateValue()">
                                <span class="pme-cart-price-to mat-h3">
                                    <b id="main-value">
                                        {{  this.currentPaymentMethod === "CREDIT_CARD" && this.installmentSelected && this.installmentSelected.installments > 0
                                            ? (this.installmentSelected.installments + 'X de ' + (this.installmentSelected.installmentValue | currency:'BRL'))
                                            : (this.cart.totalValue | currency:'BRL')
                                        }}
                                    </b>
                                </span>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>


        </div>
        <!-- </pme-mobile-dropdown> -->

        <pme-alert type="error" *ngIf="this.cartErrors && this.cartErrors.length">
            <div *ngFor="let error of this.cartErrors">{{error}}</div>
        </pme-alert>
    </div>
</div>

<ng-template #notNewPayment>
    <div *ngIf="this.cart">
        <!-- OBS 1: Quando há dois ou mais descontos na tela, o desconto do boleto deve aparecer sempre por último, já que é aplicado sobre o valor restante.  -->
        <!-- OBS 2: Usar a classe "pme-cart-nowrap" na segunda <div> da <li> quando o texto exibido é apenas um valor (por exemplo, R$ 10,00) -->

        <mat-card class="pme-cart-card notNewPayment">
            <mat-card-content>

                <!-- Se não houver nenhum <li>, ocultar toda a <div> -->
                <div
                    *ngIf="this.isUpgrade && (this.cart.title || (this.cart.appliedDiscounts && this.cart.appliedDiscounts.length))">
                    <div class="pme-product-choice-header display-utils-row display-utils-between display-utils-gap-8">
                        <div class=" title title-diff-plans">
                            Diferença entre os planos
                        </div>
                    </div>
                    <mat-divider inset></mat-divider>

                    <div class="item-margin new-plan-info display-utils-row display-utils-between-center display-utils-gap-16" style="margin-bottom: 0.375rem !important;">
                        <div>
                            {{this.cart.selfAttendanceData.upgradeData.product.name}}
                        </div>
                        <div class="pme-text-right" >
                            R$ {{formatCurrency(this.cart.selfAttendanceData.upgradeData.product.value)}}

                        </div>
                    </div>
                    <div class="old-plan-diff display-utils-row display-utils-between-center display-utils-gap-16" style="margin-bottom: 0.375rem !important; ">
                        <div>
                            {{this.cart.selfAttendanceData.contract.product.name}}
                        </div>
                        <div class="pme-text-right old-plan-diff" >
                            <b>- R$ {{formatCurrency(this.cart.currentPlanItemsSum)}}</b>

                        </div>
                    </div>

                    <div class="pme-new-coupon" *ngIf="this.checkShowFormularyCoupon(this.cart)">
                        <form class="display-utils-row-nowrap display-utils-start-start display-utils-gap-8" [formGroup]="this.couponFb">
                            <mat-form-field class="display-utils-flex-60" appearance="outline" [ngClass]="{
                                        'pme-coupon-invalid': this.couponIsInvalid && this.cart.couponIdentifier && this.isAplicarButton,
                                        'pme-coupon-applied': this.cart.hasValidAppliedCoupon
                                    }">
                                <!-- <div *ngIf="this.theresValue || this.isFocused"> -->
                                    <mat-label class="labelInput">Código do cupom</mat-label>
                                <!-- </div> -->
                                <input class="inputCoupon" matInput #couponIdentifier
                                    [(ngModel)]="this.cart.couponIdentifier"
                                    (input)="formatCoupon(); thereIsInputValue()" formControlName="couponIdentifier"
                                    placeholder="Código do cupom" (focus)="this.isFocused = true"
                                    (blur)="this.isFocused = false">


                                <mat-icon *ngIf="this.cart.hasValidAppliedCoupon" matPrefix>check_circle</mat-icon>

                        </mat-form-field>



                        <button mat-stroked-button color="primary" class="pme-coupon-button display-utils-flex-40"
                            [disabled]="!this.cart.couponIdentifier || paymentFormSubmitting"
                            *ngIf="!this.submittingCouponCode"
                            (click)="this.isAplicarButton ? removeCoupon() : applyCoupon(false)" matSuffix>
                            {{this.isAplicarButton ? "Remover" : "Aplicar" }}
                        </button>
                        <button class="pme-coupon-spinner" mat-button disabled *ngIf="this.submittingCouponCode"
                            matSuffix>
                            <mat-spinner diameter="26" aria-label="Carregando"></mat-spinner>
                        </button>
                        </form>
                        <div>

                    </div>
                    </div>
                    <mat-error class="errorMessage">{{this.couponError}}</mat-error>

                    <div *ngIf="this.cart.appliedDiscounts && this.cart.appliedDiscounts.length">
                        <ul class="pme-cart-list-content mat-body">
                            <!-- DESCONTO DO CUPOM APLICADO -->
                            <li class="display-utils-row display-utils-between-center display-utils-gap-8"
                                *ngFor="let discount of this.cart.appliedDiscounts">
                                <div *ngIf="discount.type !== 'EXTRA_BALANCE'">
                                    {{discount.title + " (" + discount.deal + " de desconto)"}}
                                </div>
                                <div class="pme-text-right pme-cart-nowrap pme-price-success"
                                    *ngIf="discount.type !== 'EXTRA_BALANCE'">
                                    {{discount.trybuy ? discount.deal : '- ' + (discount.discountAmount | currency:
                                    'R$')}}
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="divider"></div>
                    <!-- <mat-divider></mat-divider> -->
                </div>

                <div class="pme-cart-total total-upgrade">
                    <div class="pme-cart-total-content display-utils-row display-utils-between-center display-utils-gap-8">
                        <div class="mat-h3">
                            <p class="noMargin">Total a pagar</p>
                        </div>
                        <div class="pme-text-right pme-cart-nowrap" *ngIf="validateValue()">
                            <!-- <span class="pme-cart-price-from mat-body"
                                *ngIf="this.cart.baseValue !== this.cart.totalValue">{{this.cart.baseValue | currency:
                                'R$'}}</span> -->
                            <span class="pme-cart-price-to mat-h3"><b>R$ {{formatCurrency(this.cart.totalValue)}}</b></span>
                        </div>
                    </div>
                </div>

                <!-- Se não houver descrição, ocultar toda a <div> -->
                <div *ngIf="this.isUpgrade && this.cart.description" class="upgrade-card-description">
                    <!-- <mat-divider></mat-divider> -->
                    <!-- <div class="divider"></div> -->

                    <p class="mat-caption">
                        {{this.cart.description}}
                    </p>
                </div>
                <div class="display-utils-only-gt-sm change-plan" [ngClass]="{disabled: paymentFormSubmitting}">

                    <p (click)="paymentFormSubmitting ? null : return()">Voltar</p>
                </div>
            </mat-card-content>
        </mat-card>


        <!-- Recarga garantida -->
        <!-- Alterar o aria-label quando estiver ativado ou desativado para questões de acessibilidade -->
        <mat-card
            *ngIf="((this.cart.product.classificationIdentifier.includes('consulta-e-recuperacao-de-dividas') &&
                        this.cartService.carts &&
                        this.cartService.carts.length === 1 &&
                        this.cart.paymentMethod.identifier !== 'BANK_BILLET') ||
                        (this.cartService.carts &&
                        this.cartService.carts.length > 1 &&
                        this.cart.product.automaticRecharge &&
                        !this.cart.allowSaleWithoutPayment)) && (this.classificationIdentifier !== 'plano-mensal-recarga-pontual')">
            <mat-card-content>
                <div class="display-utils-row display-utils-between-start display-utils-gap-8">
                    <div class="pme-auto-recharge mat-h3">
                        <b>Recarga garantida</b>
                    </div>
                    <mat-slide-toggle [color]="'primary'" [ngModel]="this.allowAutomaticRecharge"
                        (change)="onAutomaticRechargeClick($event)" [formControl]="automaticRechargeFormControl"
                        aria-label="'Recarga garantida desativada'"></mat-slide-toggle>
                </div>
                <div class="pme-dark-secondary-text mat-body">
                    Quando seu crédito for igual menor que R$ {{automaticRechargeValueFormat()}}, será feita uma nova
                    recarga
                    no valor do pacote escolhido sem desconto aplicado.
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card *ngIf="this.showAutomaticRechargeOnlyMessage">
            <mat-card-content>
                <div class="display-utils-row display-utils-between-start display-utils-gap-8">
                    <div class="pme-dark-secondary-text mat-body">
                        <b>{{this.cart.messages.automaticRechargeOnly}}</b>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>


        <div class="pme-coupon" *ngIf="this.cart && !this.isUpgrade">
            <form [formGroup]="this.couponFb">
                <mat-form-field appearance="outline" [ngClass]="{
                        'pme-coupon-invalid': !this.cart.hasValidAppliedCoupon,
                        'pme-coupon-applied': this.cart.hasValidAppliedCoupon
                    }">

                    <mat-label>Cupom de desconto</mat-label>
                    <input matInput #couponIdentifier [(ngModel)]="this.cart.couponIdentifier" (input)="formatCoupon()"
                        formControlName="couponIdentifier" placeholder="Insira o código">
                    <mat-error>{{getCartErrors().couponIdentifier}}</mat-error>

                    <mat-icon *ngIf="this.cart.hasValidAppliedCoupon" matPrefix>check_circle</mat-icon>
                    <button mat-stroked-button color="primary" class="pme-coupon-button"
                        [disabled]="!this.cart.couponIdentifier" *ngIf="!this.submittingCouponCode"
                        (click)="this.isAplicarButton ? removeCoupon() : applyCoupon(false)" matSuffix>
                        {{this.isAplicarButton ? "Remover" : "Aplicar" }}
                    </button>
                    <button mat-button disabled *ngIf="this.submittingCouponCode" matSuffix>
                        <mat-spinner diameter="24" aria-label="Carregando"></mat-spinner>
                    </button>


                </mat-form-field>
            </form>
        </div>

        <pme-alert type="error" *ngIf="this.cartErrors && this.cartErrors.length">
            <div *ngFor="let error of this.cartErrors">{{error}}</div>
        </pme-alert>
    </div>
</ng-template>
